import clsx from "clsx";

const StepContent = ({active,content, step,shipment}) => (
  <div className={clsx({
    "ml-3  pl-9": true,
    "border-l-4 border-red-600" : active && step<5,
    "border-l-4 border-gray-300" : !active && step<5
    })} style={{minHeight: '10px'}}>
    {content}
    {shipment && (
      <>
        <p className="pt-2">
          <b>Przewoźnik:</b> {shipment.shipper}<br /> 
          <b>Numer listu:</b> {shipment.track_number}<br />
        </p>
      </>
    )}
  </div>
);

export default StepContent;